export class Transaction {
    type: string;
    vads_trans_status: string;
    vads_order_id: string;
    vads_currency: string;
    vads_amount: number;
    createdAt: Date;
    orders: {
        type: string;
        amount: number;
        amountVAT: number;
        amountTotal: number;
    };
    users: {
        type: string;
    };
    categories: {
        title: string;
    };
}

export class TransactionCreate {
    type: string;
    orderId: string;
    amount: number;
}


export class TransactionsQuery {
    readonly orderId?: string;
    readonly statut?: string;
    readonly type?: string;
    readonly from?: Date;
    readonly to?: Date;
  }



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/transactions/transactions.model.ts